<header>
  <div class="top-container">
    <a routerLink="/" class="logo" [attr.aria-label]="'ARIA-LABELS.LOGO-HEADER' | translate">
      <img src="/images/svg/logo.svg" alt="" width="180" height="46" />
    </a>
    <div class="navigation-wrapper">
      <div class="language-control-wrapper">
        <button [matMenuTriggerFor]="menu" class="lang-menu-btn">
          <div>{{ 'CORE.COMPONENTS.HEADER.TOP.LANGUAGE' | translate }}</div>
          <div class="material-icons arrow-icon" aria-hidden="true">arrow_drop_down</div>
        </button>
        <mat-menu #menu="matMenu">
          @for (entry of languages | keyvalue; track entry) {
            <button
              mat-menu-item
              class="lang-menu-item"
              (click)="onChangeLang(entry.key)"
              [class.selected-lang]="currentLang === entry.key"
            >
              <div class="name">
                <span class="name-text">{{ entry.value }}</span>
                @if (currentLang === entry.key) {
                  <div
                    role="img"
                    [attr.aria-label]="'ARIA-LABELS.SELECTED' | translate"
                    class="material-icons checked-icon"
                  >
                    done
                  </div>
                }
              </div>
            </button>
          }
        </mat-menu>
      </div>
      <button class="link-btn" type="button" routerLink="/system-messages">
        {{ 'CORE.COMPONENTS.HEADER.TOP.SYSTEM-MESSAGES.BTN-TEXT' | translate }}
      </button>
    </div>
  </div>
  <div class="bottom-container">
    <a routerLink="/" class="company-name">
      {{ 'CORE.COMPONENTS.HEADER.BOTTOM.COMPANY-NAME.LINK-TEXT' | translate }}
    </a>
    <div class="navigation-wrapper">
      <button class="link-btn" routerLink="/support">
        {{ 'CORE.COMPONENTS.HEADER.BOTTOM.NAVIGATION.LINKS.LINK-1' | translate }}
      </button>
      <button class="link-btn" routerLink="/news">
        {{ 'CORE.COMPONENTS.HEADER.BOTTOM.NAVIGATION.LINKS.LINK-2' | translate }}
      </button>
      <button class="link-btn" (click)="logInByUrl()">
        {{ 'CORE.COMPONENTS.HEADER.BOTTOM.NAVIGATION.LINKS.LINK-3' | translate }}
      </button>
    </div>
  </div>
</header>
